<template>
  <v-row>
    <v-col cols="12" sm="12" md="10">
      <v-row no-gutters>
        <v-col cols="12" sm="12" md="4" class="pt-xs-5 pt-sm-0 pt-md-0">
          <v-text-field
            v-model="code"
            placeholder="Mã hóa đơn"
            hide-details
            clearable
            filled
            dense
          />
        </v-col>
        <v-col cols="12" sm="12" md="4" class="pt-5 pt-sm-0 pt-md-0"
          ><v-autocomplete
            :items="allPaymentType"
            v-model="payment"
            item-text="title"
            item-value="status"
            clear-icon="mdi-close"
            hide-details
            filled
            dense
        /></v-col>
        <v-col cols="12" sm="12" md="4" class="pt-5 pt-sm-0 pt-md-0">
          <DateRangePicker
            placeholder="Thời gian"
            :date-range.sync="dateRange"
            dense
            filled
          />
        </v-col>
      </v-row>
    </v-col>

    <v-col
      cols="12"
      sm="12"
      md="2"
      class="d-flex pt-5 pt-sm-0 pt-md-0 d-flex justify-end"
    >
      <v-btn
        class="py-5 ma-2"
        medium
        dark
        color="amber dark-1"
        depressed
        @click="onFilterChanged"
      >
        <v-icon left>filter_alt</v-icon>Lọc
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import DateRangePicker from '@/components/basic/picker/DateRangeIOSPicker'
export default {
  components: { DateRangePicker },
  props: {
    defaultFilters: Object
  },
  data: () => ({
    code: '',
    query: '',
    status: '',
    payment: '',
    staff: null,
    time: null,
    date_gt: '',
    date_lt: '',
    dateRange: []
  }),
  computed: {
    ...mapState('constant', ['billStatus', 'paymentTypes']),
    allBillStatus() {
      return [
        {
          title: 'Tất cả',
          status: ''
        },
        ...this.billStatus
      ]
    },
    allPaymentType() {
      return [
        {
          title: 'Các hình thức thanh toán',
          status: ''
        },
        ...this.paymentTypes
      ]
    }
  },
  created() {},
  methods: {
    onFilterChanged() {
      this.date_gt = ''
      this.date_lt = ''
      if (this.dateRange.length > 1) {
        this.date_gt = moment(this.dateRange[0], 'DD/MM/YYYY')
          .startOf('date')
          .toISOString()
        this.date_lt = moment(this.dateRange[1], 'DD/MM/YYYY')
          .endOf('date')
          .toISOString()
      } else if (this.dateRange.length > 0) {
        this.date_gt = moment(this.dateRange[0], 'DD/MM/YYYY')
          .startOf('date')
          .toISOString()
        this.date_lt = moment(this.dateRange[1], 'DD/MM/YYYY')
          .endOf('date')
          .toISOString()
      }
      this.$emit('onFilterChanged', {
        title_contains: this.title,
        status: this.status,
        state: this.state,
        paymentType: this.payment,
        staff: this.requestor,
        tags_contains: this.tags,
        date_gt: this.date_gt,
        date_lt: this.date_lt,
        code_contains: this.code
      })
    }
  }
}
</script>
<style scoped>
.v-input--selection-controls,
.v-input__slot {
  margin: 0;
  padding: 0;
}
.border {
  border: solid 1px lightgray;
  border-radius: 4px;
}
</style>
